// Indicatorii urbanistici și bilanțul spațiilor verzi, pe ECRAN.
//
// Pe planșă (`SitePlanView`, exportul) rămâne tabelul de planșă — majuscule
// cursive îngroșate, chenar negru —, fiindcă așa se predă. Pe ecran același
// tabel pus într-un card arăta ca o poză lipită peste desen (Stefan,
// 26.09.2026). Aici cifrele sunt aceleași, citite din aceleași câmpuri ale
// documentului, dar scrise ca restul interfeței: numele în cuvinte, valoarea
// îngroșată, maximul lângă ea. DOAR cifre — fără bare de progres față de
// maxim: un raport P.O.T. la 41 % din limită nu e o bară de încărcare.

import { useT } from "../i18n";
import type { Cheie } from "../i18n";
import { randuriBilant, type Indicatori } from "./plan/siteGlyphs";

const zec = (v?: number, n = 2) =>
  v === undefined || v === null ? "—" : v.toFixed(n).replace(".", ",");
const mp = (v?: number) =>
  v === undefined || v === null ? "—" : `${Math.round(v).toLocaleString("ro-RO")} m²`;

export default function IndicatoriCard({ areas, indicatori }: {
  areas: Record<string, number>; indicatori?: Indicatori;
}) {
  const t = useT();
  const ind = indicatori;
  const max = (v?: number, n = 2, u = "") =>
    v === undefined ? "" : t("ind.max", { v: `${zec(v, n)}${u}` });
  const randuri: [Cheie, string, string][] = [];
  if (ind?.pot) randuri.push(["ind.pot", zec(ind.pot.valoare), max(ind.pot.limita)]);
  if (ind?.cut) randuri.push(["ind.cut", zec(ind.cut.valoare), max(ind.cut.limita)]);
  if (ind?.niveluri) {
    randuri.push(["ind.regim", ind.niveluri.regim || zec(ind.niveluri.valoare, 0),
                  max(ind.niveluri.limita, 0, ` ${t("ind.niv")}`)]);
  }
  if (ind?.supraterana !== undefined) randuri.push(["ind.supraterana", mp(ind.supraterana), ""]);
  if (ind?.subterana !== undefined) randuri.push(["ind.subterana", mp(ind.subterana), ""]);

  const lot = areas?.lot ?? 0;
  const pct = (v?: number) => (v === undefined || lot <= 0) ? ""
    : `${Math.round((v / lot) * 100)} %`;
  // aceleași rânduri ca legenda planșei, cu numele pe ecran
  const NUME: Cheie[] = ["ind.teren", "ind.verde_total", "ind.verde_sol",
                         "ind.verde_subsol", "ind.sapatura"];
  const bilant = randuriBilant(areas).map((r, i) => ({ ...r, nume: NUME[i] }));

  return (
    <div className="ind-card">
      {randuri.length > 0 && (
        <div className="ind-grup">
          <span className="lbl ind-titlu">{t("ind.titlu")}</span>
          {randuri.map(([k, v, m]) => (
            <div key={k} className="ind-rand">
              <span>{t(k)}</span>
              <span><b>{v}</b>{m && <span className="ind-max"> {m}</span>}</span>
            </div>
          ))}
        </div>
      )}
      <div className="ind-grup">
        <span className="lbl ind-titlu">{t("ind.verde")}</span>
        {bilant.map((r) => (
          <div key={r.nume} className="ind-rand">
            <span className="ind-nume">
              {r.c && <i className="ind-pastila" style={{ background: r.c }} />}
              {t(r.nume)}
            </span>
            <span><b>{mp(r.v)}</b>
              {r.nume !== "ind.teren" && pct(r.v) && <span className="ind-max"> {pct(r.v)}</span>}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
